import { EventEmitter } from 'events';

interface SubscribeEventData {
  channel: string;
  chanId: number;
  symbol: string;
}

export class Realtime extends EventEmitter {
  private socket: WebSocket;
  private bookChanId?: number;
  private tradesChanId?: number;
  private tickerChanId?: number;
  private tickerBtcChanId?: number;
  private tickerUsdChanId?: number;
  private level = 1;
  constructor(channels: object[]) {
    super();
    this.socket = new WebSocket('wss://api.bitfinex.com/ws/2');
    this.socket.onopen = () => {
      channels.forEach((channel) => {
        this.subscribe(channel);
      });
    };
    this.socket.onmessage = (message) => {
      const msg = JSON.parse(message.data);
      if (msg.event === 'subscribed') {
        this.onSubscribe(msg);
        return;
      }
      if (msg.event === 'unsubscribed') {
        this.onUnsubscribe();
        return;
      }
      if (msg.event || msg[1] === 'hb') {
        return;
      }
      if (msg[0] === this.bookChanId) {
        this.emit('book', msg);
        return;
      }
      if (msg[0] === this.tradesChanId) {
        this.emit('trades', msg);
        return;
      }
      if (msg[0] === this.tickerChanId) {
        this.emit('ticker', msg);
        return;
      }
      if (msg[0] === this.tickerBtcChanId) {
        this.emit('btcTicker', msg);
        return;
      }
      if (msg[0] === this.tickerUsdChanId) {
        this.emit('usdTicker', msg);
        return;
      }
    };
  }
  public setFactor(factor: number) {
    const level = Math.floor(Math.log10(factor)) + 1;
    if (this.level !== level) {
      this.level = level;
      this.emit('reSubscribing');
      this.subscribe({
        event: 'unsubscribe',
        chanId: this.bookChanId,
      });
    }
  }
  private subscribe(channel: object) {
    this.socket.send(
      JSON.stringify(channel),
    );
  }
  private onUnsubscribe() {
    this.subscribe({
      event: 'subscribe',
      channel: 'book',
      pair: 'tBTCUSD',
      prec: 'P' + this.level,
      len: '100',
    });
  }
  private onSubscribe(msg: SubscribeEventData) {
    switch (msg.channel) {
      case 'book':
        this.emit('subscribeOrderbook');
        this.bookChanId = msg.chanId;
        break;
      case 'trades':
        this.tradesChanId = msg.chanId;
        break;
      case 'ticker':
        switch (msg.symbol) {
          case 'fBTC':
            this.tickerBtcChanId = msg.chanId;
            break;
          case 'fUSD':
            this.tickerUsdChanId = msg.chanId;
            break;
          case 'tBTCUSD':
            this.tickerChanId = msg.chanId;
            break;
        }
        break;
    }
  }
}
